import { executeTwoStepEventQueries, executeTwoStepEventQuery } from './execute';
import {
  buildDashboardComposeRevenueQueries,
  buildDashboardRevenueQuery,
  fromDashboardComposeRevenueResponse,
  fromDashboardRevenueResponse,
  getDashboardComposeRevenueInfo,
  getDashboardRevenueInfo,
} from '../converters/revenueDashbordApiConverter';

export const executeDashboardComposeRevenueQueries = (unit, executeId) => (dispatch, getState) => {
  const state = getState();
  const queries = buildDashboardComposeRevenueQueries(state, unit);
  const dashboardComposeRevenueInfo = getDashboardComposeRevenueInfo(state, unit);

  return executeTwoStepEventQueries(queries, executeId, dispatch, getState).then((response) =>
    fromDashboardComposeRevenueResponse(response, queries, dashboardComposeRevenueInfo, unit)
  );
};

export const executeDashboardRevenueQuery = (unit, executeId) => (dispatch, getState) => {
  const state = getState();
  const query = buildDashboardRevenueQuery(state, unit);
  const dashboardRevenueInfo = getDashboardRevenueInfo(state, unit);

  return executeTwoStepEventQuery(query, executeId, dispatch, getState).then((response) =>
    fromDashboardRevenueResponse(response, query, dashboardRevenueInfo, unit)
  );
};
